<template>
<div>
    <div class="container-fluid" style="text-align: center; height: 80vh;">
        <br/><br/><br/>
        <h1><icon name="check-circle" scale="8"></icon></h1><br/>
        <h2>Congratulations! Account Created Successfully</h2><br/>
        <h4>Your email address requires verification.</h4><br/>
        <p>We have sent an email to your inbox, please click on the verification link in that email to activate and log in to your account.</p>

    </div>
</div>

</template>
<script>
  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
  }
</script>


// WEBPACK FOOTER //
// src/components/login/pending.vue